import { FilterEvent } from '../types/filterEvent';
/**
 * Composable to handle filter reset functionality.
 * @param {Function} emit - Emit function from the component.
 */
export function useResetFilter(emit) {
    const resetFilter = () => {
        emit(FilterEvent.FilterReset);
    };
    return {
        resetFilter,
    };
}
